import { useSrpContext } from '@/src/contexts'
import { RouteFaqItem } from '@/src/types/seoSrpResult'
import { useTranslations } from 'next-intl'
import { useMemo } from 'react'

import CategoryFaq from './categoryFaq'
import { GroupedFaqCategory } from './categoryFaq'

function groupByCategory (items: RouteFaqItem[]): GroupedFaqCategory[] {
    const map = new Map<string, { categoryLabel?: string; items: { question: string; answer: string }[] }>()
    for (const item of items) {
        const existing = map.get(item.category)
        if (existing) {
            existing.items.push({ question: item.question, answer: item.answer })
        } else {
            map.set(item.category, { categoryLabel: item.categoryLabel, items: [{ question: item.question, answer: item.answer }] })
        }
    }
    return Array.from(map, ([category, { categoryLabel, items }]) => ({ category, categoryLabel, items }))
}

const CategoryFaqWrapper = () => {
    const {
        SEOSrpData: { sections }
    } = useSrpContext()
    const t = useTranslations('common.routeSeoContent')

    const faq = sections?.faq
    if (!faq?.length) return null

    const groupedFaq = useMemo(() => groupByCategory(faq), [faq])
    const city = sections?.destination?.info?.title
    const title = city ? t('faqAboutCity', { city }) : ''

    return <CategoryFaq title={title} groupedFaq={groupedFaq} />
}

export default CategoryFaqWrapper
